import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SimpleModal } from 'src/app/utilities/simple-modal';
import { RequestServices } from 'src/app/services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from 'src/app/services/storage.service';
import { LogConsumoFunciones } from 'src/app/utilities/logConsumo';
import { Router } from '@angular/router';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { Configuration } from 'src/app/Constants/configuration';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';

@Component({
  selector: 'app-simple-message',
  templateUrl: './simple-message.component.html',
  styleUrls: ['./simple-message.component.css']
})
export class SimpleMessageComponent implements OnInit {
  public const: Configuration = new Configuration();
  public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
  message:String;
  accion:String;
  cancel:String;
  simpleModal:SimpleModal = SimpleModal.DEFAULT;
  capturaste:string = "";
  recomendacion:string = "";
  elegir:string = "";
  class:boolean=false;
  error:boolean=false;
  public llamar: boolean = false;
  btnOrder:String="default";
  btnsMismoEstilo:boolean = false;
  classAccion:string = "";
  classContainerAccion:string = "";
  srcImage:string = "";
  widthImage:string = "auto";
  heightImage:string = "auto";
  public telefono: string = "";
  public logConsumoId: string = "";
  public cocheSeguro: CocheSeguro = new CocheSeguro();
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  mostrarSoloEncabezadoError : boolean = false;
  mostrarTooltip:boolean = false;
  textoTooltip:string = "";

  constructor(public modalRef: MatDialogRef<SimpleMessageComponent>, 
    private router: Router,
    private requestService: RequestServices,
    private snackBar: MatSnackBar,
    private storageService: StorageService) { 
    if(this.btnOrder==""){
      this.btnOrder="default";
    }    
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
   }

  ngOnInit() {
    if(this.btnOrder==""){
      this.btnOrder="default";
    }   
    if(this.simpleModal===SimpleModal.CONFIRMAR) {
      this.elegir = this.capturaste;
    }
    this.logConsumoId = this.storageService.getItem("logConsumoId");
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
  }

  updatelogConsumo() {
    if (this.storageService.ifExist("cocheSeguro")) {
        this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
    this.cocheSeguro.telefono = this.telefono;
    this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));

    this.logConsumoFun.logConsumo()
    this.close();
}

obtenerAyuda() {
    let ayuda = this.logConsumoFun.ayudaInsert().subscribe(result => {
        if (result.error) {
            this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
        } else if (result.ok || result.Exist_log) {
            ayuda.unsubscribe();
            this.updatelogConsumo();
        }
    });
}

close() {
  if(this.btnOrder === "default"){
    this.modalRef.close(true);
  } else {
    this.modalRef.close(1);
  }
}

valida(): boolean {
  if (this.telefono == undefined || this.telefono == "" || this.telefono.length < 10) {
    return true;
  } else {
    return false;
  }
}

btnConMismoEstilo(){
  return this.btnsMismoEstilo;
}

}
